import React from "react";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { IRouterService } from "@radarly/shared/router";
import { NavigationSwitcherSearchPanel } from "./panel";
import Queries from "./queries";
import WorkspaceSearchList from "./workspaces";

interface NavigationSwitcherSearchProps {
  height: number;
  onClickItem: () => void;
  search: string;
  router: IRouterService;
}
export function NavigationSwitcherSearch({
  height,
  onClickItem,
  search,
  router,
}: NavigationSwitcherSearchProps) {
  const locale = useCurrentUserLocale();
  return (
    <NavigationSwitcherSearchPanel height={height}>
      {(tab) => (
        <>
          {tab === "queries" ? (
            <Queries
              search={search}
              onClickQuery={onClickItem}
              router={router}
            />
          ) : (
            <WorkspaceSearchList
              locale={locale}
              search={search}
              onClickWorkspace={onClickItem}
              router={router}
            />
          )}
        </>
      )}
    </NavigationSwitcherSearchPanel>
  );
}
